var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAffiliate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 272,
    viewBox: "0 0 274 272",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16839_113113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 274,
    height: 272
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 272,
    rx: 18,
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16839_113113)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_16839_113113)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.5,
    cy: 48.3362,
    rx: 47.5,
    ry: 36.8675,
    fill: "#21FF6C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -4,
    cy: 118.384,
    rx: 29,
    ry: 22.5301,
    fill: "#21FF6C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192,
    cy: 241.275,
    rx: 46,
    ry: 35.6386,
    fill: "#FF834E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.5,
    cy: 153.614,
    rx: 37.5,
    ry: 29.0843,
    fill: "#F8D59F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.5,
    cy: 234.721,
    rx: 19.5,
    ry: 15.1566,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.5,
    cy: 111.01,
    rx: 19.5,
    ry: 15.1566,
    fill: "#4ACC48"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 93C176 88.5817 172.418 85 168 85H107C102.582 85 99 88.5817 99 93V111V129C99 133.418 102.582 137 107 137H124C128.418 137 132 133.418 132 129V119C132 114.582 135.582 111 140 111H168C172.418 111 176 107.418 176 103V93Z",
    fill: "#72E260"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 160C99 164.418 102.582 168 107 168H168C172.418 168 176 164.418 176 160V142V124C176 119.582 172.418 116 168 116H151C146.582 116 143 119.582 143 124V134C143 138.418 139.418 142 135 142H107C102.582 142 99 145.582 99 150V160Z",
    fill: "url(#paint0_linear_16839_113113)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_16839_113113",
    x: -117,
    y: -72.5312,
    width: 453,
    height: 433.445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_16839_113113"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16839_113113",
    x1: 137.5,
    y1: 168,
    x2: 169,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD32"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate);
export default __webpack_public_path__ + "static/media/affiliate.b128f22d231a7b2254caa3510e5150ce.svg";
export { ForwardRef as ReactComponent };